export const fieldRequired=(value,checked)=>{
  if(value===null||(value!==null&&checked)){
    return true
  }else{
    return false
  }
}